import React, { useEffect, useState, useRef } from "react";
import {
  CardHeader,
  CardBody,
  Card,
  Col,
  Row,
  Container,
  Input,
  Button,
} from "reactstrap";
import "../../assets/css/admin.css";
import AdminNav from "./AdminNav";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { SimpleFormatTransactionID } from "utils/functions";
import CustomerCard from "./components/customer";
import TransactionCard from "./components/transaction";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GET_ADMINTRANSACTION_DETAILS } from "graphql/admin/mutations/transactions";
import {
  GET_ADMINCUSTOMER_TOGGLE_ACTIVE,
  SET_ADMINCUSTOMER_PLAID_VERIFY,
} from "graphql/admin/mutations/customers";
import { useAuth } from "components/custom/authprovider";
import sendMutationContext from "utils/sendContext";
import { useReactToPrint } from "react-to-print";
import { formatDateMDYString } from "utils/date";
import InvoiceCard from "./components/invoice/invoice.component";
import ReceiptCard from "./components/receipt/receipt.component";
import "utils/jsdocTypes";
import { RESEND_TRANSACTION_RECEIPT } from "graphql/admin/mutations/transactions";
import { GET_LAST_LOCK_NOTE_BY_CUSTOMER_ID } from "graphql/admin/queries/locknotes";
import { UPDATE_ADMINCUSTOMER_NOTES } from "graphql/admin/mutations/customers";
import { SADropdownOrOther } from "utils/functions";
import { SAlert } from "utils/functions";
import { CREATE_LOCK_NOTE } from "graphql/admin/mutations/locknotes";
import { UPDATE_DISPUTE_VALID_BY_CTRANSACTION_ID } from "graphql/admin/mutations/transactions";
import { UPDATE_DISPUTE_STATUS_BY_CTRANSACTION_ID } from "graphql/admin/mutations/transactions";
import { UPDATE_DISPUTE_NOTES_BY_CTRANSACTION_ID } from "graphql/admin/mutations/transactions";
import { DISPUTE_TRANSACTION_BY_CTRANSACTION_ID } from "graphql/admin/mutations/transactions";
import { GET_ADMINCUSTOMER_DETAILS } from "graphql/admin/mutations/customers";
import { lockNotes } from "utils/defaults";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

function TransactionLookup() {
  const [isInvoiceCardLoaded, setIsInvoiceCardLoaded] = useState(false);
  const [isReceiptCardLoaded, setIsReceiptCardLoaded] = useState(false);

  const componentRefInvoice = useRef();
  const componentRefReceipt = useRef();

  const handlePrintInvoiceCfgRef = useRef({ contentRef: componentRefInvoice });
  const handlePrintReceiptCfgRef = useRef({ contentRef: componentRefReceipt });

  const handlePrintInvoice = useReactToPrint(handlePrintInvoiceCfgRef.current);
  const handlePrintReceipt = useReactToPrint(handlePrintReceiptCfgRef.current);

  const { wt } = useAuth();

  const [logoutFlag, setLogoutFlag] = useState();
  const [transactionid, setTransactionID] = useState("");
  const { ctransactionid } = useParams();
  const history = useHistory();
  const location = useLocation();
  const initialPathRef = useRef(location.pathname);
  const basePath = (() => {
    const current = initialPathRef.current;
    const lastSlashIndex = current.lastIndexOf("/");

    if (
      current.slice(lastSlashIndex, current.length) == "/transaction-lookup"
    ) {
      return current + "/";
    }

    return current.slice(0, lastSlashIndex + 1);
  })();

  const [customer, setCustomer] = useState();
  const [transaction, setTransaction] = useState();
  const [chargebackLiability, setChargebackLiability] = useState({
    liabilityAmount: 0,
    numberOfLiability: 0,
    disputedAmount: 0,
    numberOfDisputed: 0,
  });

  const [adminTransactionLookup, { loading }] = useMutation(
    GET_ADMINTRANSACTION_DETAILS,
    sendMutationContext(wt, setLogoutFlag),
  );
  const [adminCustomerToggleActiveById] = useMutation(
    GET_ADMINCUSTOMER_TOGGLE_ACTIVE,
    sendMutationContext(wt, setLogoutFlag),
  );
  const [adminCustomerSetPlaidVerifyById] = useMutation(
    SET_ADMINCUSTOMER_PLAID_VERIFY,
    sendMutationContext(wt, setLogoutFlag),
  );
  const [adminResendTransactionReceipt] = useMutation(
    RESEND_TRANSACTION_RECEIPT,
    sendMutationContext(wt, setLogoutFlag),
  );
  const [adminCreateLockNote] = useMutation(
    CREATE_LOCK_NOTE,
    sendMutationContext(wt, setLogoutFlag),
  );
  const [adminGetLastLockNoteByCustomerId] = useLazyQuery(
    GET_LAST_LOCK_NOTE_BY_CUSTOMER_ID,
    sendMutationContext(wt, setLogoutFlag),
  );
  const [adminCustomerLookup, { loading: loadingAdminCustomerLookup }] =
    useMutation(
      GET_ADMINCUSTOMER_DETAILS,
      sendMutationContext(wt, setLogoutFlag),
    );
  const [updateCustomerNotes] = useMutation(
    UPDATE_ADMINCUSTOMER_NOTES,
    sendMutationContext(wt, setLogoutFlag),
  );

  const [disputeTransaction] = useMutation(
    DISPUTE_TRANSACTION_BY_CTRANSACTION_ID,
    sendMutationContext(wt, setLogoutFlag),
  );
  const [updateDisputeValid] = useMutation(
    UPDATE_DISPUTE_VALID_BY_CTRANSACTION_ID,
    sendMutationContext(wt, setLogoutFlag),
  );
  const [updateDisputeStatus] = useMutation(
    UPDATE_DISPUTE_STATUS_BY_CTRANSACTION_ID,
    sendMutationContext(wt, setLogoutFlag),
  );
  const [updateDisputeNotes] = useMutation(
    UPDATE_DISPUTE_NOTES_BY_CTRANSACTION_ID,
    sendMutationContext(wt, setLogoutFlag),
  );

  const searchTransaction = async (searchTransactionId = undefined) => {
    if (!logoutFlag) {
      if (transactionid !== "") {
        searchTransactionId = transactionid;
      }

      if (!searchTransactionId || searchTransactionId == "") {
        history.replace({ pathname: basePath });

        setCustomer();
        setTransaction();
        return;
      }

      setIsInvoiceCardLoaded(false);
      setIsReceiptCardLoaded(false);

      const data = await adminTransactionLookup({
        variables: { transactionid: searchTransactionId },
      });
      if (
        data &&
        data.data &&
        data.data.adminTransactionLookup.error === null &&
        searchTransactionId
      ) {
        history.replace({ pathname: basePath + searchTransactionId });
        const customer = data.data.adminTransactionLookup.customer;
        adminGetLastLockNoteByCustomerId({
          variables: {
            customerid: customer.customerid,
          },
        }).then((res) => {
          const status =
            res?.data?.getLastLockNoteByCustomerId?.status ?? false;

          if (status) {
            customer.locknote =
              res.data.getLastLockNoteByCustomerId.locknote.reason;
            customer.islock =
              res.data.getLastLockNoteByCustomerId.locknote.islock;
          }

          setCustomer(customer);
        });

        adminCustomerLookup({
          variables: { phone: customer.phone },
        }).then((res) => {
          const status = res.data.adminCustomerLookup.status ?? false;

          if (status) {
            const data = res.data.adminCustomerLookup;

            const recentTransactions = data.recenttransactions
              .slice()
              .filter(
                (transaction) =>
                  new Date(transaction.datetimecreated).getTime() >
                  new Date().getTime() - 90 * 24 * 60 * 60 * 1000,
              );
            const liabilityTransactions = recentTransactions
              .slice()
              .filter((transaction) => !transaction.disputed);
            const disputedTransactions = recentTransactions
              .slice()
              .filter((transaction) => transaction.disputed);
            setChargebackLiability({
              liabilityAmount: liabilityTransactions.reduce(
                (accumulator, currentItem) => {
                  return accumulator + currentItem.price;
                },
                0,
              ),
              numberOfLiability: liabilityTransactions.length,
              disputedAmount: disputedTransactions.reduce(
                (accumulator, currentItem) => {
                  return accumulator + currentItem.price;
                },
                0,
              ),
              numberOfDisputed: disputedTransactions.length,
            });
          }
        });

        setTransaction(data.data.adminTransactionLookup.transaction);
      } else {
        history.replace({ pathname: basePath + searchTransactionId });

        setCustomer();
        setTransaction();
      }
    }
  };

  const lockNote = (customer) => {
    const title = customer.isEnabled ? "Lock" : "Unlock";

    SADropdownOrOther(
      `${title} Note`,
      "Select the reason for the lock note",
      "Confirm",
      lockNotes,
    ).then((value) => {
      if (value) {
        adminCreateLockNote({
          variables: {
            reason: lockNotes[value] ?? value,
            customerid: customer.customerid,
          },
        })
          .then((res) => {
            const status = res?.data?.createLockNote?.status ?? false;

            if (status) {
              setCustomer((prevCustomer) => {
                return {
                  ...prevCustomer,
                  isEnabled: !prevCustomer.isEnabled,
                  locknote: res.data.createLockNote.locknote.reason,
                  islock: res.data.createLockNote.locknote.islock,
                };
              });
            } else {
              SAlert(
                "Error",
                "There was an error creating the lock note. Please try again.",
                "error",
              );
            }
          })
          .catch(() => {
            SAlert(
              "Error",
              "An error occurred while processing the request. Please try again.",
              "error",
            );
          });
      }
    });
  };

  useEffect(() => {
    if (ctransactionid) {
      setTransactionID(ctransactionid);
      searchTransaction(ctransactionid);
    }

    if (logoutFlag) {
      history.push("/admin/logout");
    }
  }, [logoutFlag, history]);

  useEffect(() => {
    if (
      isInvoiceCardLoaded &&
      isReceiptCardLoaded &&
      componentRefInvoice.current &&
      componentRefReceipt.current
    ) {
      handlePrintInvoiceCfgRef.current.documentTitle = `Invoice_${formatDateMDYString(
        transaction.datetimecreated,
      )}_${ctransactionid}`;
    }
  }, [isInvoiceCardLoaded]);

  useEffect(() => {
    if (isReceiptCardLoaded && componentRefReceipt.current) {
      handlePrintReceiptCfgRef.current.documentTitle = `Receipt_${formatDateMDYString(
        transaction.datetimecreated,
      )}_${ctransactionid}`;
    }
  }, [isReceiptCardLoaded]);

  const toggleCustomerStatus = async (customerId) => {
    const req = await adminCustomerToggleActiveById({
      variables: { id: customerId },
    });

    if (req && req.data && req.data.adminCustomerToggleActiveById) {
      const status = req.data.adminCustomerToggleActiveById.status;

      if (status) {
        if (customer.isEnabled) {
          customer.isEnabled = false;
        } else {
          customer.isEnabled = true;
        }

        setCustomer(customer);
      }
    }
  };

  const setCustomerPlaidVerify = async (customerId) => {
    const req = await adminCustomerSetPlaidVerifyById({
      variables: { id: customerId },
    });

    if (req && req.data && req.data.adminCustomerSetPlaidVerifyById) {
      const status = req.data.adminCustomerSetPlaidVerifyById.status;

      if (status) {
        if (customer.plaidverified) {
          customer.plaidverified = false;
        } else {
          customer.plaidverified = true;
        }

        setCustomer(customer);
      }
    }
  };

  const downloadInvoicePDF = async () => {
    const input = componentRefInvoice.current;
    if (!input) return;

    input.classList.add("force-black-text");

    await document.fonts.ready;

    const canvas = await html2canvas(input, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
    });

    input.classList.remove("force-black-text");

    const imgData = canvas.toDataURL("image/png");
    // const pdf = new jsPDF("p", "mm", "a4");
    const pdf = new jsPDF({
      orientation: "p",
      unit: "mm",
      format: "a4",
      compress: true,
    });

    const width = pdf.internal.pageSize.getWidth();
    const height = canvas.height * (width / canvas.width);

    pdf.addImage(imgData, "PNG", 0, 0, width, height);
    pdf.save(
      `Invoice_${formatDateMDYString(
        transaction.datetimecreated,
      )}_${ctransactionid}.pdf`,
    );
  };

  const downloadReceiptPDF = async () => {
    const input = componentRefReceipt.current;
    if (!input) return;

    input.classList.add("force-black-text");

    await document.fonts.ready;

    const canvas = await html2canvas(input, {
      scale: 2,
      useCORS: true,
      allowTaint: false,
      backgroundColor: "#ffffff",
    });

    input.classList.remove("force-black-text");

    const imgData = canvas.toDataURL("image/png");

    // const pdf = new jsPDF("p", "mm", "a4");
    const pdf = new jsPDF({
      orientation: "p",
      unit: "mm",
      format: "a4",
      compress: true,
    });

    const width = pdf.internal.pageSize.getWidth();
    const height = canvas.height * (width / canvas.width);

    pdf.addImage(imgData, "PNG", 0, 0, width, height);

    pdf.save(
      `Receipt_${formatDateMDYString(
        transaction.datetimecreated,
      )}_${ctransactionid}.pdf`,
    );
  };

  return (
    <div className="admin-wrapper">
      <AdminNav />

      <Container fluid className="content">
        <Row>
          <Col md="12">
            <Card className="card-dark">
              <CardHeader className="card-header-dark">
                <Row>
                  <Col lg="8" md="6" sm="6">
                    Transaction Lookup
                  </Col>

                  <Col lg="2" md="3" sm="3" style={{ textAlign: "right" }}>
                    <Input
                      type="text"
                      value={transactionid}
                      placeholder="Transaction ID Search"
                      onKeyUp={(e) => {
                        if (e.code === "Enter" || e.code === "NumpadEnter") {
                          searchTransaction();
                        }
                      }}
                      onChange={(e) =>
                        setTransactionID(
                          SimpleFormatTransactionID(e.target.value),
                        )
                      }
                    />
                  </Col>

                  <Col lg="2" md="3" sm="3" style={{ textAlign: "right" }}>
                    <Button
                      color={"success"}
                      onClick={() => searchTransaction()}
                    >
                      Search Transaction
                    </Button>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Row>
                  {!transaction && !loading && (
                    <span>No transaction found!</span>
                  )}

                  {loading && <span>Searching...</span>}

                  {!loading && transaction && (
                    <Col lg="6" md="6" className="customer-card ">
                      <TransactionCard
                        customer={customer}
                        transaction={transaction}
                        setTransaction={setTransaction}
                        resendTransactionReceipt={adminResendTransactionReceipt}
                        handlePrintInvoiceFn={handlePrintInvoice}
                        handlePrintReceiptFn={handlePrintReceipt}
                        disputeTransaction={disputeTransaction}
                        updateDisputeValid={updateDisputeValid}
                        updateDisputeStatus={updateDisputeStatus}
                        updateDisputeNotes={updateDisputeNotes}
                        isInvoiceCardLoaded={isInvoiceCardLoaded}
                        isReceiptCardLoaded={isReceiptCardLoaded}
                        downloadInvoicePDF={downloadInvoicePDF}
                        downloadReceiptPDF={downloadReceiptPDF}
                      />
                    </Col>
                  )}

                  {/* <Col lg="1" md="1"></Col> */}

                  {!loading && customer && (
                    <Col lg="6" md="6" className="customer-card">
                      {customer.plaidverified && (
                        <CustomerCard
                          customer={customer}
                          setCustomer={setCustomer}
                          toggleCustomerStatus={toggleCustomerStatus}
                          lockNote={lockNote}
                          updateCustomerNotes={updateCustomerNotes}
                          chargebackLiability={chargebackLiability}
                        />
                      )}

                      {!customer.plaidverified && (
                        <CustomerCard
                          customer={customer}
                          setCustomer={setCustomer}
                          toggleCustomerStatus={toggleCustomerStatus}
                          lockNote={lockNote}
                          setCustomerPlaidVerify={setCustomerPlaidVerify}
                          updateCustomerNotes={updateCustomerNotes}
                          chargebackLiability={chargebackLiability}
                        />
                      )}
                    </Col>
                  )}
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      {!loading && transaction && customer && (
        <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
          <InvoiceCard
            transaction={transaction}
            customer={customer}
            onCardLoad={() => setIsInvoiceCardLoaded(true)}
            ref={componentRefInvoice}
          />
          <ReceiptCard
            transaction={transaction}
            customer={customer}
            onCardLoad={() => setIsReceiptCardLoaded(true)}
            ref={componentRefReceipt}
          />
        </div>
      )}
    </div>
  );
}

export default TransactionLookup;
